import React from 'react'

const About: React.FC = () => {
    return (
        <div className="pt-20">
            {/* Hero Section */}
            <div className="relative h-[60vh] flex items-center justify-center bg-gray-900 overflow-hidden">
                <div className="absolute inset-0 bg-black/60 z-10" />
                <img
                    src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=2070&auto=format&fit=crop"
                    alt="About Us"
                    className="absolute inset-0 w-full h-full object-cover"
                />
                <div className="relative z-20 text-center text-white px-4">
                    <h1 className="text-5xl font-bold font-bricolage mb-4">About Us</h1>
                    <p className="text-xl max-w-2xl mx-auto text-gray-200">
                        Your trusted partners for research-driven real estate investments in Gurgaon & Uttarakhand.
                    </p>
                </div>
            </div>

            {/* Content Section - Split Layout */}
            <section className="py-24 px-4 max-w-7xl mx-auto">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center">
                    <div className="relative">
                        <div className="absolute -top-4 -left-4 w-24 h-24 bg-primary-100 rounded-full z-0" />
                        <img
                            src="/team/daljeet.png"
                            alt="Mr. Daljeet - Founder"
                            className="relative z-10 rounded-2xl shadow-2xl w-full object-cover object-top h-[600px]"
                            loading="lazy"
                        />
                        <div className="absolute -bottom-6 -right-6 w-full max-w-xs bg-white p-6 rounded-xl shadow-xl z-20 border-l-4 border-primary-500">
                            <p className="text-4xl font-bold text-gray-900 mb-2">25+</p>
                            <p className="text-gray-600 mb-4">Years of experience in delivering verified value deals.</p>
                            <div className="border-t border-gray-100 pt-4 mt-2">
                                <h4 className="text-xl font-bold text-gray-900">Mr. Daljeet Singh Bhatia</h4>
                                <p className="text-primary-600 font-medium">Founder</p>
                            </div>
                        </div>
                    </div>

                    <div className="space-y-6">
                        <h2 className="text-primary-500 font-bold tracking-widest uppercase text-sm">Who We Are</h2>
                        <h3 className="text-4xl font-bold text-gray-900 font-bricolage">
                            Research-Based <span className="text-primary-600">Wealth Creation</span>
                        </h3>
                        <p className="text-gray-700 leading-relaxed text-lg">
                            At Singh's Best Buy, we believe real estate is more than just a transaction—it’s a precision instrument for wealth generation. We don't just sell properties; we are <span className="font-bold text-gray-900">research-driven aggregators</span> who analyze market trends to bring you only the most secure, high-appreciation opportunities.
                        </p>
                        <p className="text-gray-700 leading-relaxed text-lg">
                            From exclusive <span className="font-bold text-gray-900">land parcels in Uttarakhand</span> (Dehradun, Haridwar, Mussoorie) to premium commercial and residential assets in Gurgaon, every listing is vetted for title clarity, legal compliance, and future growth potential.
                        </p>

                        <div className="pt-6 grid grid-cols-2 gap-8">
                            <div>
                                <h4 className="text-xl font-bold text-gray-900 mb-2">Our Philosophy</h4>
                                <p className="text-gray-700">Data-backed decisions, zero-risk documentation, and transparent advisory.</p>
                            </div>
                            <div>
                                <h4 className="text-xl font-bold text-gray-900 mb-2">Our Specialization</h4>
                                <p className="text-gray-700">Large land parcels & HNI-grade investment portfolios.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            {/* Team Section - Disabled until all images are available
            <section className="py-24 pb-40 bg-gray-50">
                <div className="max-w-7xl mx-auto px-4">
                    <div className="text-center mb-16">
                        <h2 className="text-4xl font-bold font-bricolage mb-4">Meet Our Experts</h2>
                        <p className="text-gray-700 max-w-2xl mx-auto">The minds behind your wealth creation.</p>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
                        {[
                            { name: "Mr. Siddhart", role: "Senior Consultant", image: "https://images.unsplash.com/photo-1659353220482-554773c2f7fa?q=80&w=1080&auto=format&fit=crop" },
                            { name: "Mr. Sehas", role: "Senior Consultant", image: "https://images.unsplash.com/photo-1642364861013-2c33f2dcfbcf?q=80&w=1080&auto=format&fit=crop" },
                            { name: "Mr. Timsu", role: "Senior Consultant", image: "https://images.unsplash.com/photo-1659355894117-0ae6f8f28d0b?q=80&w=1080&auto=format&fit=crop" },
                            { name: "Mr. Prince", role: "Senior Consultant", image: "https://images.unsplash.com/photo-1659353221603-7c9d5fe2a4bb?q=80&w=1080&auto=format&fit=crop" },
                            { name: "Mr. Parinay", role: "Senior Consultant", image: "/team/parinay.jpg" },
                        ].map((member, index) => (
                            <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden group hover:shadow-xl transition-shadow">
                                <div className="h-80 bg-gray-200 relative overflow-hidden flex items-center justify-center">
                                    {member.image ? (
                                        <img
                                            src={member.image}
                                            alt={member.name}
                                            className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-300"
                                        />
                                    ) : (
                                        <div className="text-gray-500 font-medium">Image Needed</div>
                                    )}
                                </div>
                                <div className="p-6 text-center">
                                    <h4 className="text-xl font-bold text-gray-900">{member.name}</h4>
                                    <p className="text-primary-600 font-medium">{member.role}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            */}
        </div>
    )
}

export default About
